import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
import { saveAs } from 'file-saver';
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class Seguimiento_exp_Service {
    [x: string]: any;

    public url;
    public identity;
    public token;
    constructor(
        private _http: Http,
        private _http2: HttpClient
    ) {
        this.url = GLOBAL.url;
    }

    getSolicitudes(rut) {
        let params = {
            rut: rut
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url + 'seguimiento_expediente', params, { headers: headers })
            .pipe(map(res => res.json()));
    }


    getExp(rut, numero, departamento) {
        let params = {
            rut: rut,
            numero: numero,
            departamento: departamento

        };

        let headers = new Headers({
            'Content-type': 'application/json',
            /*  'Authorization': sessionStorage.getItem("token-domCloud") */
        });

        return this._http.post(this.url + 'seguimiento_solicitud', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getActa(exp) {
        let params = {
            exp: exp

        };

        let headers = new Headers({
            'Content-type': 'application/json',
            /*  'Authorization': sessionStorage.getItem("token-domCloud") */
        });

        return this._http.post(this.url + 'acta_expediente', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getExpediente(data) {
        console.log(data)
        let params = {
            num: data.num,
            rut: data.rut,
            depto: data.depto,
        };

        let headers = new Headers({
            'Content-type': 'application/json',
            /*  'Authorization': sessionStorage.getItem("token-domCloud") */
        });

        return this._http.post(this.url + 'get/expediente', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    downloadAttachment(id_firma) {
        const params = {
            id_firma: id_firma
        };

        const headers = new Headers({
            /*  'Authorization': sessionStorage.getItem("token-domCloud") */
        })

        return this._http.post(this.url + 'download/acta', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    downloadDocuments(id_doc, doc_name, nombre) {
        const params = {
            id_doc: id_doc,
            nombre: nombre
        };

        const headers = new HttpHeaders({
            /* 'Authorization': sessionStorage.getItem("token-domCloud") */
        })

        return this._http2.post(this.url + 'download/documents', params, { headers, responseType: "blob" }).toPromise()
            .then(blob => {
                console.log(blob)
                saveAs(blob, doc_name);
            })
            .catch(err => console.error("download error = ", err))
    }

    downloadDocumentsReitero(id_doc, doc_name, nombre) {
        const params = {
            id_doc: id_doc,
            nombre: nombre
        };

        const headers = new HttpHeaders({
            /* 'Authorization': sessionStorage.getItem("token-domCloud") */
        })

        return this._http2.post(this.url + 'download/documents_reitero', params, { headers, responseType: "blob" }).toPromise()
            .then(blob => {
                console.log(blob)
                saveAs(blob, doc_name);
            })
            .catch(err => console.error("download error = ", err))
    }
  
    getDocuments(id_doc) {
        console.log(id_doc)
        const params = {
            id_doc: id_doc
        };


        let headers = new Headers({
            'Content-type': 'application/json',
            /*  'Authorization': sessionStorage.getItem("token-domCloud") */
        });

        return this._http.post(this.url + 'get/documents', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getDocumentsReitero(id_doc) {
        console.log(id_doc)
        const params = {
            id_doc: id_doc
        };


        let headers = new Headers({
            'Content-type': 'application/json',
            /*  'Authorization': sessionStorage.getItem("token-domCloud") */
        });

        return this._http.post(this.url + 'get/documents_reitero', params, { headers: headers })
            .pipe(map(res => res.json()));
    }


    downloadReitero_pdf(id_soL, doc_name) {
        const params = {
            id_soL: id_soL,
        };

        const headers = new HttpHeaders({
            /*  'Authorization': sessionStorage.getItem("token-domCloud") */
        })
        return this._http2.post(this.url + 'download/reitero/pdf', params, { headers, responseType: "blob" }).toPromise()
            .then(blob => {
                console.log(blob)
                saveAs(blob, doc_name);
            })
            .catch(err => console.error("download error = ", err))
    }

    getReiteros_list(id_soL) {
        console.log(id_soL)
        const params = {
            id_soL: id_soL
        };


        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url + 'get/reiteros_list', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    getObs_Reiteros(id_soL, actReiteros) { /* rut, exp, sol */
        const params = {
            id_soL: id_soL,
            actReiteros: actReiteros
        };


        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        });

        return this._http.post(this.url + 'get/observacion_reiteros', params, { headers: headers })
            .pipe(map(res => res.json()));
    }

    uploadObsReitero(files, id_sol, formType = "") {
        const formData = new FormData();

        formData.append('id_sol', id_sol)
        formData.append('formType', formType)
        const headers = new Headers({
            /*   'Content-type': 'application/json', */
            'Authorization': sessionStorage.getItem("token-domCloud")
        })
        console.log(files)
        files.map((file) => {
            if (!(file == null || file == undefined)) {
                let doExt = file.doc.name.split(".")
                doExt = file.name + '-' + new Date().getTime() + '.' + doExt[doExt.length - 1]
                let fil: File
                fil = file.doc
                formData.append('uploads[]', fil, doExt);
            }
        })
        console.log(formData)
        /*  const params = {
             libro_folio: libro_folio,
             formData: formData
            }; */
        return this._http.post(this.url + '/upload/observacion_reiteros', formData, { headers: headers })
            .pipe(map((res) => res.json()))
    }

}